export default __webpack_public_path__ + "static/media/schedule messages.8bdf8186.svg";